export default "__VITE_ASSET__090c65b0__"